/**
 * 信息流类
 * 主要功能：
 * 1 处理多tab的信息流
 * 2 处理pc软广
 * ***/
function feed()  {
    // 判断传参个数
    if(arguments.length==2){
        var data = arguments[0],
        insert = arguments[1];
    } else if(arguments.length==3){
        var data = arguments[0],
        event = arguments[1],
        insert = arguments[2]; 
    }
    let feedConfig = {
        adlist: [], 
        feedTabData: {},//信息流数据{0:{insertStartIdx:0}} tab 页数据 insertStartIdx 插入位置
        feedRequestData:{},
        maxnum:0,
        marginnum:2
    };
    if(Array.isArray(data)){
        feedConfig.adlist = data;
    }else{
        feedConfig.maxnum = data.maxnum;
        feedConfig.adlist = data.list;
    }
    feedConfig.data = {}//信息流辅助数据，用来记录广告id和div
    if(arguments.length==2){
        initHandler(data);
    } else if(arguments.length==3){
        //这条数据
        event.on('init', initHandler);
        event.on("loadMoreCmp",loadMoreHandler);
    }
    //初始化操作
    function initHandler(data) {
        if (typeof data == 'undefined') {
            data = { index: 0 };
        }
        if (!feedConfig.feedTabData.hasOwnProperty(data.index)) {
            feedConfig.feedTabData[data.index] = { insertStartIdx: 0, apData: {}, posApMap:{}};
        }
        insertAd(feedConfig, insert, data);
    }
    //加载更多操作
    function loadMoreHandler(data) {
        if (data.hasOwnProperty("data")) data = data.data;
        insertAd(feedConfig, insert, data);
    }
}
//插入广告
function insertAd(feedConfig, insert, data) {
    
    let feedTabData = feedConfig.feedTabData[data.index];

    let feedAdData = feedConfig.data;

    let feedRequestData = feedConfig.feedRequestData;//信息流广告请求数据结构
    
    let aidsObj = { aids: [] }, insertArr = [], replaceArr = [], elObj={};//插入和替换数组 

    let noContentInserArr = [], noContentReplaceArr =[];//没有返回内容插入和替换数组
    //
    for (var i = feedTabData.insertStartIdx;i < feedConfig.adlist.length; i++){
        let item = feedConfig.adlist[i];
        let pos = item.pos;
        if(typeof item.pos=="object"){
            if(item.pos.hasOwnProperty(data.index)){
                pos = item.pos[data.index];
            }else{
                pos = item.pos["default"];
            }
        }
        if(data.hasOwnProperty("rec_len")){
            pos = pos - data.rec_len;
        }
        if (pos > data.len + 1) {
            feedTabData.insertStartIdx = i;
            break;
        } else {
            //广告位置分为，插入和替换2种方式 showType 展示方式 0 替换 1 插入
            let elDiv = document.createElement("DIV");
            elDiv.setAttribute("p_" + item.ap, "");
            item.showType == '1'? data.len++ : null;
            feedTabData.apData[item.ap] = {
                index: pos - 1,
                showType: item.showType,
                dom: elDiv
            };
            feedTabData.posApMap[pos - 1] = item.ap;
            //信息流的广告,feedAdData如果没有数据，则说明从来没有发过请求或者没有广告,没有广告则重新请求。
            if (!feedAdData.hasOwnProperty(item.ap) || !feedRequestData.hasOwnProperty(item.ap)) {
                feedAdData[item.ap] = { item: item };
                elObj[item.ap] = elDiv;
                let adObj = {};
                for (let key in item) {
                    if (key != "pos" && key != "showType") adObj[key] = item[key];
                }
                aidsObj.aids.push(adObj);
            } else {
                //判断对应ap是否有返回内容，如果有则记录到替换中
                if (feedAdData[item.ap].hasOwnProperty("content")){
                    if (item.showType == "0") {
                        replaceArr.push(pos - 1);
                    } else {
                        insertArr.push(pos - 1);
                    }
                }else{
                    //记录下来没有广告内容的广告，如果已经发了请求,则缓存起来，
                    if(feedRequestData.hasOwnProperty(item.ap)){
                       // feedRequestData[item.ap].action = insert;
                        if (item.showType == "0") {
                            noContentReplaceArr.push(pos - 1);
                        } else {
                            noContentInserArr.push(pos - 1);
                        }
                    }
                }
            }
        }
        if(i == feedConfig.adlist.length-1){
            feedTabData.insertStartIdx = feedConfig.adlist.length;
        }
    }

    if (noContentReplaceArr.length + noContentInserArr.length>0){
      //  feedRequestData.action.push({ replaceArr: noContentReplaceArr, insertArr: noContentInserArr, insert: insert});
    }
    if (aidsObj.aids.length > 0) {
        //elObj el和ap对应关系  aidsObj 广告数据 {aids: []}
        recordRequestData(feedRequestData,aidsObj)
        IfengAmgr.show(elObj, aidsObj, { DataCmp : function (data) {
            //数据返回的插入和替换数组
            let dataReplaceArr = [], dataInsertArr = [];
            //处理完后
            for (let key in data) {
                if (feedRequestData.hasOwnProperty(key)) {
                    feedRequestData[key].load = 1;
                }
                //code 有值时候，再去插入
                if (data[key].code!=""){
                    //数据
                    feedAdData[key].content = {
                        ap:key,
                        code: data[key].code,
                        w: feedAdData[key].item.w,
                        h: feedAdData[key].item.h,
                        murls: [],//下次不在发送曝光地址
                        curls: data[key].curls||[],
                        encode:false //不需要编码
                    };
                    //获得当前 广告数据
                    let tabAdItemData = feedTabData.apData[key];
                    if (tabAdItemData.showType == "0"){
                        dataReplaceArr.push(tabAdItemData.index)
                    }else{
                        dataInsertArr.push(tabAdItemData.index)
                    }
                }
            }
            if (dataInsertArr.length + dataReplaceArr.length >0){
                insert(dataInsertArr.sort(sortNumber), dataReplaceArr.sort(sortNumber), (dom) => {
                    //没有内容
                    mutilInsert(dom, feedTabData, feedAdData, false);
                });
            }
            //需要判断是否有通一位置不通tab的dom已经展示，需要缓存insert函数。然后把
            return true;
        }},false)
    }
    
    if (insertArr.length + replaceArr.length > 0) {
        insert(insertArr.sort(sortNumber), replaceArr.sort(sortNumber), (dom) => {
            //已经有内容
            mutilInsert(dom, feedTabData, feedAdData, true);
        });
    }
}
/***
* 记录请求数据
*/
function recordRequestData(feedRequestData, data){
    let { aids} = data;
    for(let item of aids){
        feedRequestData[item.ap] = {load:0,action:null};
    }
}
/****
 * 多元素插入
 * dom 插入后参数
 * feedTabData 信息流tab页数据，每个tab页一个数据
 * feedAdData 广告数据配置
 * setContent 是否设置内容
 *  */
function mutilInsert(dom, feedTabData, feedAdData,setContent=false){
    for (let key in dom) {
        let realDiv = dom[key];
        let adAp = feedTabData.posApMap[key];
        let renderEl = feedTabData.apData[adAp].dom;
        if (Array.isArray(realDiv)) {
            for (let i = 0; i < realDiv.length; i++) {
                if (i == 0) {
                    setContent ? insertEl(realDiv[0], renderEl, adAp, feedAdData[adAp].content) : insertEl(realDiv[0], renderEl, adAp);
                } else {
                    insertEl(realDiv[i], document.createElement("DIV"), adAp, feedAdData[adAp].content);
                }
            }
        } else {
            setContent ? insertEl(realDiv, renderEl, adAp, feedAdData[adAp].content) : insertEl(realDiv, renderEl, adAp);
        }
    }
}
//单个元素插入操作
function insertEl(outEl, renderEl,adAp,adData=null){
    renderEl.setAttribute("pp_" + adAp, "");
    //先清除之前dom的内容，然后插入新的内容
    if (outEl.innerHTML != "") {
        outEl.innerHTML ="";
    }
    outEl.appendChild(renderEl);
    if (adData!=null){
        IfengAmgr.setAdElContent({ ...adData, el: renderEl });
    }
}
function sortNumber(a,b){
    return a - b
}
if (typeof  window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.feed = {render: feed, version: "2.0.0"};
}